/** Timing of the live-update fallback (screens §3.1), in one place: the stream hook, the polling interval and the room check share it. */

/** The stream counts as unhealthy once it has been closed this long. */
export const SSE_UNHEALTHY_AFTER_MS = 10_000;

/** While unhealthy every query refetches this often (inside the 5–10 s band the spec sets). */
export const SSE_POLL_MS = 7_500;
